import { render, staticRenderFns } from "./DetectionListMyImageLayout.vue?vue&type=template&id=3f7e2d33&scoped=true"
import script from "./DetectionListMyImageLayout.vue?vue&type=script&lang=js"
export * from "./DetectionListMyImageLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7e2d33",
  null
  
)

export default component.exports